import { timeStamp } from "console";

const locale = "de-DE";
const timeZone = "UTC";

export const formattedTime = (timestamp: number): string => {
  if (!timestamp) {
    return "--:--";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(timestamp));
};

export const formattedDateArticle = (timestamp: number): string => {
  if (!timestamp) {
    return "--";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(timestamp));
};

export const formattedDate = (timestamp: number): string => {
  if (!timestamp) {
    return "Unbekannt";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    day: "numeric",
    month: "numeric",
    year: "numeric",
  }).format(new Date(timestamp));
};

export const formattedDateFull = (timestamp: number): string => {
  if (!timestamp) {
    return "Unbekannt";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    weekday: "long",
    day: "numeric",
    month: "numeric",
    year: "numeric",
  }).format(new Date(timestamp));
};

export const formattedDateFullShort = (timestamp: number): string => {
  if (!timestamp) {
    return "Unbekannt";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
  }).format(new Date(timestamp));
};


export function formatTimestampForPlayer(input: string | number): string {
  const totalSeconds = parseInt(input.toString());
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secondsLeft = totalSeconds % 60;

  if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
  } else if (minutes >= 10) {
      return `${minutes}:${secondsLeft.toString().padStart(2, '0')}`;
  } else {
      return `${minutes}:${secondsLeft.toString().padStart(2, '0')}`;
  }
}
